module.exports = __webpack_public_path__ + "static/img/70069A_2_R_20190920_LC.19f9e88.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/70069A_2_R_20190920_LC.png
// module id = s2bm
// module chunks = 0